/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button} from '@mui/material';

import textureSvg from './texture.svg';

export const RestrictionBlockRoot = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  backgroundColor: theme.palette.semantic_dark?.surface.surface1,
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    backgroundImage: `url(${textureSvg})`,
    backgroundRepeat: 'repeat',
    backgroundSize: '16px 16px',
    opacity: 0.2,
    pointerEvents: 'none',
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const TextBlock = styled(Box)(({theme}) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const Title = styled(Box)(({theme}) => ({
  fontSize: 18,
  fontWeight: 600,
  lineHeight: '20px',
  letterSpacing: '0.36px',
  color: theme.palette.semantic_dark?.surface.onSurface,
}));

export const Description = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '16px',
}));

export const RestoreButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.semantic_dark?.primary.main,
  color: theme.palette.semantic_dark?.primary.on,
  borderRadius: theme.spacing(2),
  padding: '14px 16px',
  fontSize: 16,
  lineHeight: '20px',
  textTransform: 'none',
  alignSelf: 'stretch',
  display: 'flex',
  gap: theme.spacing(2),
  flexShrink: 0,
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: theme.palette.semantic_dark?.primary.hover,
  },
  [theme.breakpoints.down('md')]: {
    width: `calc(100% - ${theme.spacing(8)})`,
    margin: theme.spacing(0, 4, 4, 4),
  },
}));
